export default __webpack_public_path__ + "static/media/fevr-roadmap.7c409448.svg";